import {
    Formik,
    FormikProps
} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {
    AccountApplication,
    AccountApplicationFormType,
    AccountApplicationRecordFormProps,
    AccountApplicationStatus
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: AccountApplicationRecordFormProps) => {

    const onSubmit = (values: AccountApplicationFormType) => {
        handleSubmit(values as AccountApplication);
    };

    let initialValues = {
        accountApplicationStatus: AccountApplicationStatus.ACTIVE,
    } as AccountApplicationFormType;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik<AccountApplicationFormType>
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<AccountApplicationFormType>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
